import { hasValue } from 'src/shared/utils/common';

import type { TConstantPadValues, TPadValues, TPreparationStatus, TRawPadPreparation } from './types';

const constantPadPreparationProperties: (keyof TConstantPadValues)[] = [
  'id',
  'blockId',
  'fieldId',
  'padId',
  'planVersionId',
  'padName',
  'fieldName',
  'blockName',
  'unplannedWellCount',
  'drilled',
] as const;
const editablePadPreparationProperties: (keyof TPadValues)[] = [
  'landLeaseDate',
  'forestProjectDate',
  'padDocumentationComment',
  'routeReadyDate',
  'routeTypeId',
  'routeComment',
  'routeDocumentationDate',
  'routeDocumentationComment',
  'electricityDate',
  'electricityComment',
  'isChanged',
] as const;

export const getConstAndEditablePadValues = (
  rawPad: TRawPadPreparation,
): { constant: TConstantPadValues; editable: TPadValues } => {
  const constValues = constantPadPreparationProperties.reduce((acc: Record<string, unknown>, key) => {
    acc[key] = rawPad[key] ?? null;

    return acc;
  }, {});

  const editableValues = editablePadPreparationProperties.reduce((acc: Record<string, unknown>, key) => {
    acc[key] = rawPad[key] ?? null;

    return acc;
  }, {});

  return { constant: constValues as TConstantPadValues, editable: editableValues as TPadValues };
};

export const getReadinessStatusByDates = (currentDate: number, date: number | null): TPreparationStatus => {
  if (!hasValue(date)) {
    return 'notReady';
  }

  if (currentDate >= date) {
    return 'ready';
  }

  return 'inProcess';
};
